import { LAYOUTS, PERMISSIONS } from '@/enum';
const RelayHub = () => import(/* webpackChunkName: "tenant.relay_hub" */ '@/views/Admin/Tenants/components/RelayHub');
const Quickbooks = () =>
  import(/* webpackChunkName: "tenant.quickbooks" */ '@/views/Admin/Tenants/components/Integrations/Quickbooks');
const FeatureFlags = () =>
  import(/* webpackChunkName: "tenant.feature_flags" */ '@/views/Admin/Tenants/components/FeatureFlags');
const QuickbooksRedirect = () =>
  import(
    /* webpackChunkName: "tenant.quickbooks.redirect" */ '@/views/Admin/Tenants/components/Integrations/Quickbooks/QuickbooksRedirect.vue'
  );
const Tenants = () => import(/* webpackChunkName: "tenants" */ '@/views/Admin/Tenants');
const TenantList = () => import(/* webpackChunkName: "tenant_list" */ '@/views/Admin/Tenants/components/TenantList');
const Tenant = () => import(/* webpackChunkName: "tenant" */ '@/views/Admin/Tenants/components/Tenant');
const Admin = () => import(/* webpackChunkName: "admin" */ '@/views/Admin');
const Administrators = () => import(/* webpackChunkName: "administrators" */ '@/views/Admin/Administrators');
const TenantProfile = () => import(/* webpackChunkName: "tenant.profile" */ '@/views/Admin/Tenants/components/Profile');
const AdminList = () =>
  import(/* webpackChunkName: "administrators.list" */ '@/views/Admin/Administrators/components/UserList');
const AdminUser = () => import(/* webpackChunkName: "users.user" */ '@/views/Users/components/User');
const AdminUserProfile = () => import(/* webpackChunkName: "users.profile" */ '@/views/Users/components/UserProfile');
const Integrations = () =>
  import(/* webpackChunkName: "integrations" */ '@/views/Admin/Tenants/components/Integrations');

const AssessmentManagement = () =>
  import(/* webpackChunkName: "assessment-management" */ '@/views/Admin/AssessmentManagement');
const PublisherList = () =>
  import(
    /* webpackChunkName: "publisher-list" */ '@/views/Admin/AssessmentManagement/components/Publishers/PublisherList.vue'
  );
const AssessmentList = () =>
  import(
    /* webpackChunkName: "assessments" */ '@/views/Admin/AssessmentManagement/components/Assessments/AssessmentList.vue'
  );
const AssessmentDetails = () =>
  import('@/views/Admin/AssessmentManagement/components/Assessments/AssessmentDetails.vue');
const Tools = () => import(/* webpackChunkName: "tenant.tools" */ '@/views/Admin/Tenants/components/Tools');

export default [
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
    children: [
      {
        path: '',
        name: 'tenants',
        component: Tenants,
        children: [
          {
            path: '',
            name: 'tenantList',
            component: TenantList,
          },
          {
            path: '/admin/tenant/:id',
            name: 'tenant',
            component: Tenant,
            children: [
              {
                path: '',
                name: 'tenant.profile',
                component: TenantProfile,
              },
              {
                path: 'integrations',
                name: 'tenant.integrations',
                component: Integrations,
                children: [
                  {
                    path: 'quickbooks',
                    name: 'tenant.integrations.quickbooks',
                    component: Quickbooks,
                  },
                  {
                    path: 'relayhub',
                    name: 'tenant.integrations.relayhub',
                    component: RelayHub,
                  },
                ],
              },
              {
                path: 'feature_flags',
                name: 'tenant.feature_flags',
                component: FeatureFlags,
              },
              {
                path: 'tools',
                name: 'tenant.tools',
                component: Tools,
              },
            ],
          },
        ],
      },
      {
        path: 'tenant/quickbooks_redirect',
        name: 'tenant.quickbooks_redirect',
        component: QuickbooksRedirect,
      },
      {
        path: 'administrators',
        name: 'administrators',
        component: Administrators,
        children: [
          {
            path: '',
            name: 'administrators.list',
            component: AdminList,
          },
          {
            path: ':id',
            name: 'administrators.user',
            component: AdminUser,
            children: [
              {
                path: '',
                name: 'administrators.userProfile',
                component: AdminUserProfile,
              },
            ],
          },
        ],
      },
      {
        path: 'assessment-management',
        name: 'assessment-management',
        component: AssessmentManagement,
        redirect: { name: 'assessment-management.publishers' },
        children: [
          {
            path: 'publishers',
            name: 'assessment-management.publishers',
            component: PublisherList,
          },
          {
            path: 'assessments',
            name: 'assessment-management.assessments',
            component: AssessmentList,
          },
          {
            path: 'assessments/:id',
            name: 'assessment-management.details',
            component: AssessmentDetails,
          },
        ],
      },
    ],
    meta: {
      layout: LAYOUTS.ADMIN,
      title: 'Admin - eLuma Insight',
      permission: [PERMISSIONS.VIEW_ADMINISTRATION],
    },
  },
];
